import React, { Fragment } from "react";
import {
  Sparkles,
  Camera,
  Users,
  Zap,
  CheckCircle2,
  Globe,
  Gem,
  Car,
  Heart,
  ShieldCheck,
  X,
} from "./Icons";

const PricingModal = ({ isOpen, onClose, mobile, countryCode }) => {
  if (!isOpen) return null;

  const pricingOptions = [
    {
      name: "Single Portrait",
      price: countryCode !== "IN" ? "1.00" : "45.00",
      description:
        "Perfect for professional headshots, deck yourselves with attire, automibiles, global locations, creative solo projects, etc.",
      features: [
        "Professional Studio Headshots",
        "Graduation & Academic Attire",
        "High-Fashion & Luxury Jewelry",
        "Interaction with Automobiles & Pets",
        "Global Locations & Backdrops",
        "Advanced Identity Preservation",
        "Style Replication Engine",
      ],
      icon: <Camera className="w-6 md:h-6 text-indigo-400" />,
      color: "indigo",
    },
    {
      name: "Family & Group",
      price: countryCode !== "IN" ? "1.50" : "90.00",
      description:
        "Ideal for family Portraits (studio, in-home or global locations), corporate teams, and friend groups. Decorate individually or as a group.",
      features: [
        "All Single Portrait Features",
        "Corporate Team Composites",
        "Family & Friend Group Synthesis",
        "Individual Member Customization",
        "Global Group Reference Library",
        "Posture & Composition Cloning",
        "Cohesive Lighting & Atmosphere",
      ],
      icon: <Users className="w-6 md:h-6 text-emerald-400" />,
      color: "emerald",
      popular: true,
    },
  ];

  return (
    // <div className="fixed inset-0 z-[70] flex items-center justify-center md:p-4 bg-black/90 backdrop-blur-md animate-in fade-in duration-300">
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/90 backdrop-blur-md animate-in fade-in duration-300"
      style={{ zIndex: "100", padding: "1rem" }}
    >
      {/* <div className="glass w-full h-full md:max-w-5xl md:max-h-[90vh] md:rounded-[2.5rem] overflow-hidden flex flex-col border-white/10 shadow-2xl"> */}
      <div
        // className="glass w-full h-full md:max-w-5xl md:max-h-[90vh] overflow-hidden flex flex-col border-white/10 shadow-2xl"
        className="glass w-full h-full  md:max-h-[90vh] overflow-hidden flex flex-col border-white/10 shadow-2xl"
        style={{ borderRadius: "3rem", width: mobile ? "100%" : "70%" }}
      >
        {/* <div className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40"> */}
        <div
          className="px-6 py-4 md:px-8 md:py-6 border-b border-white/5 flex justify-between items-center bg-slate-900/40"
          style={{ padding: mobile ? "" : "2rem" }}
        >
          <div className="flex items-center gap-3">
            <div className="md:w-10 md:h-10 bg-indigo-600 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/20">
              <Zap className="text-white md:w-6 md:h-6" />
            </div>
            <h2 className="text-xl font-bold text-white tracking-tight">Pricing</h2>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-all">
            <X className="md:h-6 w-6 text-slate-400" />
          </button>
        </div>

        {/* <div className="flex-1 overflow-y-auto p-6 md:p-10 space-y-12"> */}
        <div
          className="flex-1 overflow-y-auto space-y-12"
          style={{ padding: mobile ? "1rem" : "2rem" }}
        >
          <div className="text-center space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-sm font-medium">
              <Zap className="w-4 md:h-4" />
              <span>Simple, Transparent Pricing</span>
            </div>
            <h1 className="text-4xl md:text-5xl text-white font-bold tracking-tight">
              Professional Art, <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-emerald-400">
                Without the Studio Fees.
              </span>
            </h1>
            <p className="text-lg text-slate-400 max-w-2xl mx-auto leading-relaxed">
              Pay only for what you create. No subscriptions, no hidden costs, no commitments.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mt-30">
            {pricingOptions.map((option, idx) => (
              <div
                key={idx}
                // className={`relative p-8 rounded-[2.5rem] bg-slate-800/40 border transition-all hover:scale-[1.02] duration-300 ${
                className={`relative space-y-6 rounded-[2rem] bg-slate-800/40 border transition-all hover:scale-[1.02] duration-300 ${
                  option.popular
                    ? "border-emerald-500/50 shadow-2xl shadow-emerald-500/10"
                    : "border-slate-700"
                }`}
                style={{
                  padding: mobile ? "1rem" : "3rem",
                  borderColor: option.popular ? "rgba(16, 185, 129, 0.5)" : "",
                }}
              >
                {option.popular && (
                  <div
                    // className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-[10px] font-bold px-4 py-1 rounded-full uppercase tracking-widest shadow-lg"
                    className="absolute text-white text-[10px] font-bold px-4 py-1 rounded-full uppercase tracking-widest shadow-lg"
                    style={{
                      top: "-14px",
                      left: mobile ? "35%" : "40%",
                      backgroundImage: "linear-gradient(to right, #10b981, #14b8a6)",
                      height: "24px",
                      width: "125px",
                    }}
                  >
                    Most Popular
                  </div>
                )}

                <div className="flex justify-between items-start mb-8">
                  <div
                    className={`w-14 h-14 rounded-2xl flex items-center justify-center ${
                      option.color === "indigo" ? "bg-indigo-500/10" : "bg-emerald-500/10"
                    }`}
                  >
                    {option.icon}
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-slate-500 font-bold uppercase tracking-widest mb-1">
                      Only
                    </div>
                    <div className="text-4xl font-bold flex items-baseline justify-end gap-2">
                      <span className="text-2xl text-slate-400">
                        {countryCode !== "IN" ? "$" : "₹"}
                      </span>
                      {option.price}
                      <span className="text-sm text-slate-500 font-medium">/gen</span>
                    </div>
                  </div>
                </div>

                <h3 className="text-2xl text-white font-bold mb-3">{option.name}</h3>
                <p className="text-slate-400 text-sm mb-8 leading-relaxed">{option.description}</p>

                <div className="space-y-4">
                  {option.features.map((feature, fIdx) => (
                    <div key={fIdx} className="flex items-center gap-3 text-sm text-slate-300">
                      <CheckCircle2
                        className={`w-5 md:h-5 flex-shrink-0 ${
                          option.color === "indigo" ? "text-indigo-400" : "text-emerald-400"
                        }`}
                      />
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* 4K Add-on Section */}
          {/* <div className="p-8 md:p-12 rounded-[3rem] bg-gradient-to-br from-slate-800/80 to-slate-900/80 border border-white/5 relative overflow-hidden group"> */}
          <div
            className="rounded-[2rem] bg-gradient-to-br from-slate-800/80 to-slate-900/80 border border-white/5 relative overflow-hidden group"
            style={{ padding: mobile ? "1rem" : "3rem", marginTop: "50px", marginBottom: "50px" }}
          >
            {/* <div className="absolute top-0 right-0 p-12 opacity-5 group-hover:opacity-10 transition-opacity"> */}
            <div
              className="absolute top-0 opacity-1 group-hover:opacity-10 transition-opacity"
              style={{
                padding: mobile ? "1rem" : "3rem",
                display: mobile ? "" : "flex",
                justifyContent: mobile ? "" : "end",
                alignContent: mobile ? "end" : "",
                placeItems: mobile ? "center" : "",
              }}
            >
              <Sparkles
                // className="w-48 h-48 text-white"
                className={mobile ? "w-100 h-100 text-white" : "w-150 h-150 text-white"}
              />
            </div>

            <div className="flex flex-col md:flex-row items-center gap-10 relative z-10">
              {/* <div className="flex-shrink-0 w-24 h-24 bg-amber-500/10 rounded-[2rem] flex items-center justify-center border border-amber-500/20"> */}
              <div
                className="bg-amber-500/10 rounded-[2rem] flex items-center justify-center border border-amber-500/20"
                style={{ height: "75px", width: "75px" }}
              >
                <Gem className="w-12 h-12 text-amber-400" />
              </div>
              {/* <div className="flex-grow text-center md:text-left"> */}
              <div className="flex-grow text-left md:text-left space-y-4">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-[10px] font-bold uppercase tracking-widest mb-4">
                  Premium Add-on
                </div>
                <h2 className="text-3xl text-white font-bold mb-4">Ultra-HD 4K Upscaling</h2>
                <p className="text-slate-400 leading-relaxed max-w-2xl">
                  Elevate your portraits to gallery-quality resolution. Our 4K engine adds surgical
                  detail and texture, making your images ideal for professional printing,
                  large-scale framing, and high-resolution displays.
                </p>
              </div>
              <div className="flex-shrink-0 text-center">
                <div className="text-sm text-slate-500 font-bold uppercase tracking-widest mb-1">
                  Add for only
                </div>
                <div className="text-4xl font-bold text-amber-400">
                  {countryCode !== "IN" ? "+$0.50" : "+₹45.00"}
                </div>
                <div className="text-xs text-slate-500 mt-2 font-medium">per image</div>
              </div>
            </div>
          </div>

          {/* Tax Section */}
          {/* <div className="p-8 md:p-12 rounded-[3rem] bg-gradient-to-br from-slate-800/80 to-slate-900/80 border border-white/5 relative overflow-hidden group"> */}
          <div
            className="rounded-[2rem] bg-gradient-to-br from-slate-800/80 to-slate-900/80 border border-white/5 relative overflow-hidden group"
            style={{ padding: mobile ? "1rem" : "3rem", marginTop: "50px", marginBottom: "50px" }}
          >
            <div className="flex flex-col md:flex-row items-center gap-10 relative z-10">
              {/* <div className="flex-shrink-0 w-24 h-24 bg-amber-500/10 rounded-[2rem] flex items-center justify-center border border-amber-500/20"> */}

              {/* <div className="flex-grow text-center md:text-left"> */}
              <div className="flex-grow text-left md:text-left space-y-4">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-[10px] font-bold uppercase tracking-widest mb-4">
                  Other charges
                </div>
                <h2 className="text-3xl text-white font-bold mb-4">Convenience charges & Taxes</h2>
                <p className="text-slate-400 leading-relaxed max-w-2xl">
                  {countryCode !== "IN" ? (
                    <Fragment>
                      <span>&bull; A 5% convenience charge is applicable to all purchases.</span>
                      <br></br>
                      <span>
                        &bull; Additional taxes maybe applicable as per regulations on all
                        purchases.
                      </span>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <span>&bull; A 5% convenience charge is applicable to all purchases.</span>
                      <br></br>
                      <span>
                        &bull; 18% GST taxes are applicable as per regulations on all purchases.
                      </span>
                    </Fragment>
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
            <div className="flex flex-col items-center gap-2">
              <Car className="w-6 md:h-6" />
              <span className="text-[10px] font-bold uppercase tracking-widest">Automobiles</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Heart className="w-6 md:h-6" />
              <span className="text-[10px] font-bold uppercase tracking-widest">
                Pets & Animals
              </span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Globe className="w-6 md:h-6" />
              <span className="text-[10px] font-bold uppercase tracking-widest">
                Global Locations
              </span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <ShieldCheck className="w-6 md:h-6" />
              <span className="text-[10px] font-bold uppercase tracking-widest">
                Secure Payments
              </span>
            </div>
          </div>
        </div>

        <div className="px-6 py-6 md:px-8 md:py-6 border-t border-white/5 bg-slate-900/80 flex justify-end">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-8 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs tracking-widest rounded-xl shadow-lg transition-all active:scale-95"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
};

export default PricingModal;
